<template>
	<div class="free-packages-vue">
					
		<form id="mainForm" class="ui form" method="post" action="">
			<input type="hidden" name="content_list" id="content_list">
			
			<div class="ui vertically padded grid">
				
				<div class="row stackable">
					<div class="four wide column" id="store_filter">
						<div class="ui vertical fluid accordion menu store_group" v-if="!isEmpty(primaryCourses)" ref="accordion-os">
							<div class="item">
								<div class="title">
									<i class="dropdown icon"></i>
									<strong>Osnovna šola</strong>
								</div>
								<div class="content filter_options">
									<div class="ui form">
										<div class="grouped fields">
											<div class="field" v-for="(course, key) in primaryCourses">
												<div class="ui checkbox">
													<input type="checkbox" :id="'primaryCourse-' + key" name="middle_school" v-model="selectedCourses" :value="course.id" />
													<label :for="'primaryCourse-' + key">{{course.label}}</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="ui vertical fluid accordion menu store_group" v-if="!isEmpty(highCourses)" ref="accordion-ss">
							<div class="item">
								<div class="title">
								  	<i class="dropdown icon"></i>
								  	<strong>Srednja šola</strong>
								</div>
								<div class="content filter_options">
									<div class="ui form">
										<div class="grouped fields">
											<div class="field" v-for="(course, key) in highCourses">
												<div class="ui checkbox">
													<input type="checkbox" :id="'highCourse-' + key" name="high_school" v-model="selectedCourses" :value="course.id" />
													<label :for="'highCourse-' + key">{{course.label}}</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>
					<div class="twelve wide column">
						<div class="ui items">
                            <div class="item" id="nav-buttons-top">
                                <div class="content">
                                    <button v-on:click.prevent="goBack" class="ui button">Nazaj</button>
                                    <button v-on:click.prevent="submit" name="submit" class="ui right floated yellow button" v-bind:class="{disabled: selectedPackages.length == 0}">Na potrditev nakupa</button>
                                </div>
                            </div>
							<div class="dimmable item" ref="dimmable">
								<div class="ui inverted dimmer">
									<div class="ui active loader"></div>
								</div>
								<div id="store_table_wrapper" class="content">
									<table class="ui selectable table" id="store_list">
										<tbody>
											<tr colspan="3" class="package-row" v-if="packageList.length == 0">
												<td class="left aligned middle aligned one wide">
													Za izbrane predmete ni gradiv.
												</td>
											</tr>
											<template v-else>
												<tr class="package-row" v-bind:class="{active: packageSelected(pack)}" v-for="(pack, key) in paginatedPackages" v-on:click="togglePackage(pack)">
													<td class="left aligned middle aligned one wide">
														<div class="ui checkbox">
															<input type="checkbox" :id="'package-' + key" name="package" :checked="packageSelected(pack)">
															<label :for="'package-' + key"></label>
														</div>
													</td>
													<td class="left aligned middle aligned twelve wide">
														<div class="ui items">
															<div class="item cover-and-title">
																<div class="ui tiny image pack">
																	<img v-on:error="onImageError" alt="naslovnica" :src="'images/packages/' + (pack.legacyId ? pack.legacyId : pack.creditId) + '.jpg'">
															    </div>
															    <div class="middle aligned content">
															    	<h3 class="ui header">{{pack.title}}</h3>
															    	<div class="description">
															        	<p>{{pack.description}}</p>
															      	</div>
															    </div>
															  </div>
														</div>
										 			</td>
													<td class="packagePrice right aligned middle aligned three wide">
														{{pack.price | formatPrice}}
													</td>
												</tr>
											</template>
										</tbody>
										<tfoot v-if="packageList.length > 0">
											<tr>
												<th colspan="3">
													<div id="pagination" class="ui right floated bottom fitted circular labels">
														<template v-if="page != 1">
															<a class="ui label" v-on:click="page--">
																<i class="left chevron fitted icon"></i> <strong>Prejšnja</strong>
															</a>
															<a class="ui label" v-on:click="page = 1">
																<strong>1</strong>
															</a>
															...
														</template>

														<span class="ui yellow disabled label">{{page}}</span>
														
														<template v-if="page != totalPages">
															...
															<a class="ui label" v-on:click="page = totalPages">
																<strong>{{totalPages}}</strong>
															</a>
															<a class="ui label" v-on:click="page++">
																<strong>Naslednja</strong> <i class="right chevron fitted icon"></i>
															</a>
														</template>
													</div>
												</th>
											</tr>
										</tfoot>
									</table>

								</div>
							</div>
							<div class="item">
								<div class="content">
									<div id="generic-message" class="ui error message"></div>
								</div>
							</div>
							
							<div class="item" id="nav-buttons">
								<div class="content">
									<button v-on:click.prevent="goBack" class="ui button">Nazaj</button>
									<button v-on:click.prevent="submit" name="submit" class="ui right floated yellow button" v-bind:class="{disabled: selectedPackages.length == 0}">Na potrditev nakupa</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		 </form>
	</div>
</template>

<script>
	import store from '../store'

    export default {
    	data() {
    		return {
    			error: null,
    			packages: [],
    			courses: [],
    			selectedPackages: [],
    			selectedCourses: [],
    			page: 1,
    			perPage: 10,
    			schoolType: 'os',
    		}
    	},
    	mounted() {

    		$(this.$refs['dimmable']).dimmer('show');
    		axios.get(this.route('nakup-gradiva')).then((response) => {
    			let data = response.data;
				this.packages = data.packages;
				this.courses = data.courses;
				this.schoolType = data.school.type;

				// restore cart
				if (_.isArray(store.state.cart) && store.state.cart.length > 0) {
					for (let i = 0; i < store.state.cart.length; i++) {
						let id = store.state.cart[i].productId;
						let item = _.find(this.packages, { productId: id });
						this.selectedPackages.push(item);
					}
				}

				this.$nextTick(() => {
					let accordion = this.schoolType == 'os' ? 'accordion-os' : 'accordion-ss';
					$(this.$refs['accordion-os']).accordion('refresh');
					$(this.$refs['accordion-ss']).accordion('refresh');
					$(this.$refs[accordion]).accordion('open', 0);
					$(this.$refs['dimmable']).dimmer('hide');
				});
    		});
        },
        methods: {
        	goBack(event) {
        		window.location.href = this.route('izbirka');
        	},
        	submit(event) {
        		store.commit('cart', this.selectedPackages, 'productId');
        		window.location.href = this.route('nakup-gradiva-potrditev');
        	},
        	openHelp() {
        		this.$root.$emit('add-popup', helpModal);
        	},
        	isEmpty(object) {
        		return _.isEmpty(object);
        	},
        	togglePackage(item) {
        		let index = this.selectedPackages.indexOf(item);
        		if (index > -1) {
        			this.selectedPackages.splice(index, 1);
        		} else {	
        			this.selectedPackages.push(item);
        		}
        	},
        	packageSelected(item) {
        		return this.selectedPackages.indexOf(item) > -1;
        	},
        	onImageError(event) {
        		event.currentTarget.src = '/images/no-image.png';
        	}
        },
        watch: {
	    	selectedCourses() {
	    		this.page = 1;
	    	}
        },
        computed: {
        	highCourses() {
        		return _.filter(this.courses, { type: 'ss' });
        	},
        	primaryCourses() {
        		return _.filter(this.courses, { type: 'os' });
        	},
        	totalPages() {
        		return Math.ceil(this.packageList.length / this.perPage);
        	},
        	paginatedPackages() {
        		return this.packageList.slice((this.page - 1) * this.perPage, this.page * this.perPage);
        	},
        	packageList() {
        		let list = [];
        		if (this.selectedCourses.length == 0) {
        			list = this.packages.slice();
        		} else {
        			for (let i = 0; i < this.packages.length; i++) {
        				let item = this.packages[i];
	        			if (_.intersection(item.courseIds, this.selectedCourses).length > 0) {
	        				list.push(item);
	        			}
	        		}
        		}
        		return list;
        	}
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/BuyPackages.vue